module.exports = __webpack_public_path__ + "media/application/images/svgs/share-dark-8fc9323692b76860b7303252f2503b61.svg";